    <div class="flex items-start justify-between">
        <div class="text-xl font-medium tracking-tight leading-6 truncate">N. application per area geografica in Italia (il conteggio non contempla le Application dall'Estero)</div>

    </div>
    <div class="flex flex-col flex-auto mt-6 h-auto">
        <app-dashboard-chart
                class="items-center justify-center w-full h-full"
                [chartData]="zoneChart"></app-dashboard-chart>
    </div>
    <div class="mt-8">
        <div class="-my-3 divide-y area-grid">
            <ng-container *ngFor="let dataset of zoneData?.series; let i = index">
                <div class="grid custom-legend-grid py-3">
                    <div class="flex items-center">
                        <div
                                class="flex-0 w-2 h-2 rounded-full"
                                [style.backgroundColor]="zoneChart.colors[i]"></div>
                        <div class="ml-3 truncate">{{zoneChart.labels[i]}}</div>
                    </div>
                    <div class="font-medium text-right">{{dataset.numberValue | number:'1.0-0'}}</div>
                    <div class="text-right text-secondary">{{dataset.percentageValue}}%</div>
                </div>
            </ng-container>
        </div>
    </div>
